import React from 'react';
import PropTypes from 'prop-types';
import '../../../stylesheets/checkAndSuppliesResourceCenter.scss';
import '../../../stylesheets/main.scss';

const ArticleCard = ({ data, isSmall }) => {
  return (
    <div
      className={`details ${isSmall ? `${data.bottomMargin}` : ''} ${
        data.boxStyle ? data.boxStyle : ''
      }`}
    >
      <h4 className="smallTitle">{data.smallHeader}</h4>
      <br />
      <h2 className={`${isSmall ? 'Faqheading' : 'heading'}`}>{data.heading}</h2>
      <br />
      <p
        className={`font-weigth-medium ${isSmall ? `font-16px` : 'font-19px padding-bottom-10px'} ${
          data.paraStyle ? data.paraStyle : ''
        }`}
      >
        {data.description}
      </p>
      <br />
      <a className={`font-weigth-medium ${isSmall ? 'font-16px' : 'font-19px'}`} href={data.link}>
        {' '}
        Read more
      </a>
    </div>
  );
};
ArticleCard.propTypes = {
  data: PropTypes.objectOf(Object),
  isSmall: PropTypes.bool,
};

export default ArticleCard;
